import { Transformer } from "../../../../Transformer/index.js";
import Api from "../../../../Api/AddressProgram/DocumentApi";
import i18n from "../../../../Frontends/Common/utils/i18n";

export class DocumentService {
  constructor() {
    this.transformer = new Transformer();
    this.Api = new Api();
  }
  async setPart(fields) {
    return await this.transformer.setFormPart(this.Api, "editDocument", fields);
  }
  async set() {
    return await this.transformer.setForm(this.Api, "editDocument");
  }
  async grid(args) {
    return await this.transformer.getGrid(this.Api, "getDocuments", args);
  }
  async get(id) {
    return await this.transformer.getGridPanel(this.Api, "getDocument", null, id);
  }
  async create(model) {
    return await this.transformer.createItem(this.Api, "createDocument", model);
  }
  async delete(model) {
    return await this.transformer.deleteItem(this.Api, "deleteDocument", model);
  }
  async update(model) {
    return await this.transformer.editItem(this.Api, "editDocument", model);
  }
  async getTypes() {
    const types = [
      { label: i18n.global.t("documentPlanTab"), value: "plan" },
      { label: i18n.global.t("documentFactTab"), value: "fact" },
    ]
    const data = {records: types}
    return Promise.resolve( { data })
  }
}
